import moment from '@/assets/setups/moment'
import { getYear } from '@/assets/scripts/dateBuilders'

/** Get All Months
@returns { array } - list of all months
*/
export const getAllMonths = () => {
    return moment.months()
}

/* List of all months capitalized */
export const monthNames = getAllMonths().map(a => a.charAt(0).toUpperCase() + a.substr(1))

/** Parse list of last years according numbersOfYears
@date { string } - initial date
@numbersOfYears { number or string } - number of years you want to go back
@returns { array } - list last years according numbersOfYears
*/
export const parseLastYears = (date, numbersOfYears) => {
    const years = []

    for (let i = 0; i < numbersOfYears; i++) {
        const year = date.setFullYear(new Date().getFullYear() + i * -1)
        years.push(getYear(year))
    }

    return years
}

/*************************************************
*                                                *
*                   Begin Date                   *
*                                                *
*************************************************/
/** Parse list of months when it's the current year, does not show every month
@date { string } - date
@returns { array } - list of months for Option Begin Date Dropdown
*/
export const parseCurrentMonthsBeginDate = (date) => {
    const months = []
    const numberMonths = date ? (date - 1) : new Date().getMonth()

    for (let i = 0; i <= numberMonths; i++) {
        const month = monthNames[i]
        months.push(month)
    }

    return months
}

/** Parse list of months, depending on the final month that we chose in the form
@date { string } - date
@returns { array } - list of months for Option Begin Date Dropdown
*/
export const parseMonthsBeginDate = (date) => {
    const months = []

    for (let i = 0; i <= date.getMonth(); i++) {
        const month = monthNames[i]
        months.push(month)
    }

    return months
}

/*************************************************
*                                                *
*                    End Date                    *
*                                                *
*************************************************/
/** Parse list of months when it's the current year, does not show every month
@date { string } - date
@returns { array } - list of months for Option End Date Dropdown
*/
export const parseCurrentMonthsEndDate = (date) => {
    const months = []
    const currentMonth = new Date().getMonth()
    const numberMonths = currentMonth - (date - 1)

    if (date !== '') {
        for (let i = 0; i <= numberMonths; i++) {
            const month = monthNames[(date - 1) + i]
            months.push(month)
        }

        return months
    }

    for (let i = 0; i <= currentMonth; i++) {
        const year = monthNames[i]
        months.push(year)
    }

    return months
}

/** Parse list of months, depending on the final month that we chose in the form
@date { string } - date
@returns { array } - list of months for Option End Date Dropdown
*/
export const parseMonthsEndDate = (date) => {
    const months = []
    const numberMonths = 12 - date.getMonth()

    for (let i = 0; i < numberMonths; i++) {
        const month = monthNames[date.getMonth() + i]
        months.push(month)
    }

    return months
}
